import React from "react";
import Help from "./Help";
import StatsRtxReport from "./Report";
import View from "common/View";

const StatsRtx = () => (
  <View title="Average TCP Retransmissions Over Time" Help={Help}>
    <StatsRtxReport />
  </View>);

export default StatsRtx;
